import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {getProductById, setProduct, editProduct} from "../../../redux/actions/product";

import {Grid, Row, Col} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import ProductListFields from 'app-components/Products/FieldLists/ProductListFields.jsx';
import ProductFieldListDetails from 'app-components/Products/FieldLists/ProductFieldListDetails.jsx';
import ProductFieldListInput from 'app-components/Products/FieldLists/ProductFieldListInput.jsx';


class ProductFieldLists extends React.Component {

    constructor(props) {
        super(props);

        const id = props.match.params.id;

        if (id !== '0') {
            props.getProductById(id);
        }

        this.state = {
            edit: false,
            field: 'contreIndicationsListe',
            tags: []
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!prevProps.product && this.props.product) {
            const field = this.props.product[this.state.field];
            if(field) {
                this.setState({tags: field.split(',')});
            }
        }
    }

    componentWillUnmount() {
        this.props.setProduct(null);
    }

    toggleEdit = () => {
        this.setState({edit: !this.state.edit, tags: []});
    };

    setField = (field) => {
        this.setState({field: field, tags: []});
    };

    setTags = val => {
        this.setState({tags: val});
    };

    saveList = (field, list) => {
        this.props.editProduct(Object.assign({}, this.props.product, {
            [field]: list.join(',')
        }));
    };

    render() {

        const rightPane = this.state.edit ? (
            <ProductFieldListInput
                field={this.state.field}
                loading={this.props.loading}
                tags={this.state.tags}

                saveList={this.saveList}
                setTags={this.setTags}
            />
        ) : (
            <ProductFieldListDetails
                field={this.state.field}
                product={this.props.product}/>
        );

        return (
            <div className="main-content">
                <Card
                    content={
                        <Grid fluid>
                            {this.props.loading && !this.props.product ? (
                                <Row>
                                    <Col sm={12}>
                                        <p>
                                            <i className="fa fa-spinner fa-spin"/> Recherche du produit en cours...
                                        </p>
                                    </Col>
                                </Row>
                            ) : (
                                <div>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <ProductListFields setField={this.setField} field={this.state.field}/>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <div className="text-right" style={{marginBottom: '16px'}}>
                                                <Button bsStyle={this.state.edit ? "default" : "warning"}
                                                        onClick={() => this.toggleEdit()}>
                                                    {this.state.edit ? "Annuler" : "Modifier"}
                                                </Button>
                                            </div>

                                            {this.props.product ? rightPane : (
                                                <p>
                                                    <i className="fa fa-spinner fa-spin"/> Chargement du produit en cours...
                                                </p>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Grid>
                    }
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.status.loading,
        product: state.products.product,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getProductById: id => {
            dispatch(getProductById(id));
        },
        setProduct: val => {
            dispatch(setProduct(val));
        },
        editProduct: product => {
            dispatch(editProduct(product));
        }
    }
};

ProductFieldLists.propTypes = {
    match: PropTypes.object,

    loading: PropTypes.bool,
    product: PropTypes.object,

    getProductById: PropTypes.func,
    setProduct: PropTypes.func,
    editProduct: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductFieldLists);